<template>
  <div id="head">
    <h1>Pin {{ name.slice(-3) }}</h1>
    <p><img src="@/assets/images/macnum.png" alt="" /> {{pinNumber}} <img class="battery" :src="image" height="14"/></p>
  </div>
</template>


<script>
  export default {
    props: ['values', 'name','pinNumber'],
    data () {
      return {
        batteryImages: {
          0: require('../../assets/images/batterij_vol_zwart.png'),
          1: require('../../assets/images/batterij_leeg_zwart.png'),
          2: require('../../assets/images/batterij_leeg_zwart.png')
        }
      }
    },
    computed: {
      image () {
        let status = this.values["batteryStatus"];
        return this.batteryImages[status];
      }
    }
  }
</script>


<style>
  #head {
    text-align: center;
    padding: 0px;
    margin: 0px;
  }
</style>
